import { stickyVariables } from "./variables.js";
import { runFunctionInView, removeHashOnButtonClick } from "./utilities.js";

//=====================================================================
// Handle the Events
//=====================================================================
export function handleStickyEvents() {
    
    const { stickyGroups, stickyGroupsFromTopArray, stickySections, stickySectionsFromTopArray, pageScrollPosition } = stickyVariables();
    
    // Check if the sticky section is the current section under the navigation (at the top of the page)
    stickySectionsFromTopArray.forEach((sectionDistanceFromTop, index) => {
        runFunctionInView(() => handleStickyButtons(stickySections[index].parentElement.querySelectorAll('[data-stickyNav]'), stickySections[index].getAttribute("id")), sectionDistanceFromTop, stickySections, pageScrollPosition, -100, index);
    });
    
    // Check if the sticky section is the current section under the navigation (at the top of the page)
    stickyGroupsFromTopArray.forEach((groupDistanceFromTop, index) => {
        runFunctionInView(() => handleStickyGroup(stickyGroups[index], stickyGroups),
            groupDistanceFromTop, stickyGroups, pageScrollPosition, -5, index);

        // Remove 'groupIsActive' if scrolled above the group
        //if (pageScrollPosition < groupDistanceFromTop) {
        //    stickyGroups[index].classList.remove('groupIsActive');
        //}



        // VV Needs Refactoring VV  !!!!!
        const buttonsInGroup = Array.from(stickyGroups[index].querySelectorAll('[data-stickyNav]'));
        const groupHeight = parseFloat(getComputedStyle(stickyGroups[index]).height.replace('px',''));
        const groupBottom = groupDistanceFromTop + groupHeight;

        if (pageScrollPosition < groupDistanceFromTop) {
            stickyGroups[index].classList.remove('groupIsActive');
            buttonsInGroup.forEach(button => button.classList.remove('buttonIsActive'));
            buttonsInGroup[0].classList.add('buttonIsActive');
        }
        if (pageScrollPosition > groupBottom) {
            buttonsInGroup.forEach(button => button.classList.remove('buttonIsActive'));
            buttonsInGroup[buttonsInGroup.length - 1].classList.add('buttonIsActive');
        }
    }); 
}


export function functionHandleButtonEvents() {
    const buttons = Array.from(document.querySelectorAll('[data-stickyNav]'));

    buttons.forEach(button => {
        if (!button.dataset.listenerAdded) {
            button.addEventListener('click', (event) => { // Prevent duplicate listeners
                // Prevent default behavior of navigating to the anchor
                event.preventDefault();

                let buttonHref = button.getAttribute("href");
                let targetSection = document.querySelector(buttonHref); // Find the section to scroll to

                // Smooth scroll to the target section
                if (targetSection) {
                    targetSection.scrollIntoView({behavior: "smooth"});
                }

                // Update the URL without the hash
                let windowURL = window.location.href.split("#")[0]; // Remove any existing hash
                history.replaceState(null, null, windowURL); 
            });
            button.dataset.listenerAdded = "true"; // Mark as handled
        }
    })
}


//=====================================================================
// Handle the Sticky Buttons
//=====================================================================
export function handleStickyButtons(stickyButtonsInGroup, currentStickySection) {
    // If the sticky Buttons match the current item then set the active class
    stickyButtonsInGroup.forEach(button => {
        const buttonHref = button.getAttribute("href").replace("#", "");
        if (buttonHref === currentStickySection) {
            button.classList.add("buttonIsActive");
        } else {
            button.classList.remove("buttonIsActive");
        }

        removeHashOnButtonClick(button)  
    });
}


//=====================================================================
// Handle the Sticky Groups
//=====================================================================
export function handleStickyGroup(currentStickySection, stickyGroups) {
    stickyGroups.forEach((_group, index) => {
        if (stickyGroups[index] === currentStickySection) {
            currentStickySection.classList.add("groupIsActive");
        } else {
            stickyGroups[index].classList.remove("groupIsActive");
        }
    })
}